import {logger} from '../../../libs/shared/core/src/services/logger/logger';

export const chatPushLogger = logger.getLogger('chat-push');
